
export const Docs = {
	COMPONENT_LEVEL_COVERAGE: 'https://docs.sealights.io/knowledgebase/whats-new/2024/december-2024/component-level-coverage-for-all-test-stages',
	COVERAGE_CALCULATION: 'https://docs.sealights.io/llc-knowledge-base/coverage-calculation',
	WHATS_NEW: 'https://docs.sealights.io/knowledgebase/whats-new/whats-new-highlights',
	SUPPORT_PORTAL: 'http://support.sealights.co/servicedesk',
	AGENT_RELEASE_NOTES: 'https://www.sealights.io/release-notes/',
	TRICENTIS_ACADEMY_PORTAL: 'https://academy.tricentis.com/pages/105/tricentis-sealights-product-training',
	USER_KNOWLEDGE_BASE: 'https://docs.sealights.io/knowledgebase',
	SETUP_AND_CONFIGURATION: 'https://sealights.atlassian.net/wiki/spaces/SUP/overview',
	API_DOCS: 'https://api-doc.sealights.io/',
	LEGAL: 'https://www.sealights.io/privacy-policy/',
	TERMS_OF_USE: 'https://www.sealights.io/terms-of-service/',
	QUALITY_GATES: 'https://docs.sealights.io/knowledgebase/features/settings/quality-gates',
	CD_ONLY_INFO: 'https://sealights.atlassian.net/wiki/spaces/SUP/pages/3163848778/SeaLights+CD+Agent',
	LAB_CTS_INFO: 'https://sealights.atlassian.net/wiki/spaces/SUP/pages/3878027266/Managing+Test+Stages+in+Sealights#Continuous-Test-Stage-(CTS)',
	TOKENS_ACCESS_LEVEL: 'https://docs.sealights.io/knowledgebase/features/settings/token-access-and-management',
	TEST_STAGE_CYCLES: 'https://docs.sealights.io/knowledgebase/intro-to-sealights/technical-overview/test-stage-run',
	INTRODUCING_TEST_STAGE_CYCLES: 'https://docs.sealights.io/knowledgebase/whats-new/2024/november-2024/introducing-test-stage-runs#optimizing-test-cycles-with-tsr-based-recommendations'
};
